import React, { useState, useContext } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import 'bulma/css/bulma.min.css';

import { ScanTypeSlug, ScanType } from '../../scanTypes.ts';
import { updateScanType } from '../../api/api.ts';
import { BeamlineContext } from '../../beamlineProvider.tsx';


interface DeprecateScanTypeProps {
  scantypeslug: ScanTypeSlug;
}


const DeprecateScanType: React.FC<DeprecateScanTypeProps> = (props) => {

  const beamlineContext = useContext(BeamlineContext);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [deprecate, setDeprecate] = useState<boolean>(false);

  const [inProgress, setInProgress] = useState<boolean>(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string | null>(null);

  function getScanType(): ScanType | undefined {
    if (!props.scantypeslug) { return undefined; }
    return beamlineContext.scanTypes.typesBySlug.get(props.scantypeslug);
  }

  function clickedOpen() {
    const thisScanType = getScanType();
    if (!inProgress && !isOpen && thisScanType) {
      setIsOpen(true);
      setDeprecate(thisScanType.deprecated);
    }
  }

  async function pressedSubmit() {
    const thisScanType = getScanType();
    if (!thisScanType) { return; }

    setSubmitErrorMessage(null);
    setInProgress(true);

    const result = await updateScanType({slug: thisScanType.slug, deprecated: deprecate});
    setInProgress(false);
    if (!result.success) {
      setSubmitErrorMessage(result.message || "");
    } else {
      thisScanType.deprecated = deprecate;
      beamlineContext.changed();
      setIsOpen(false);
    }
  };

  function clickedClose() {
    if (!inProgress) { setSubmitErrorMessage(null); setIsOpen(false); }
  }

  return (
    <a className="dropdown-item" onClick={ clickedOpen }>Deprecation Status

      <div id="modal-add-sample" className={ isOpen ? "modal is-active" : "modal" }>
        <div className="modal-background"></div>

        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Deprecate Scan Type</p>
            <button className="delete" aria-label="close" onClick={ clickedClose }></button>

          </header>
          <section className="modal-card-body">

            <div className="block">
              <p>
                Setting this Scan Type as deprecated will hide it from users when they're selecting a Scan Type for their samples.
              </p>
              <p>
                All the Scan Type information and current uses of it will remain intact, and you can un-deprecate it any time.
              </p>
            </div>

            <div className="block">
              <div className="field">
                <div className="control">
                  <label className="checkbox">
                    <input type="checkbox" checked={deprecate} onChange={() => setDeprecate(!deprecate)} style={{ "marginRight": "0.5em" }} />
                    Deprecated
                  </label>
                </div>
              </div>
            </div>

            <div className="buttons">
              <input
                type="button"
                className="button is-primary"
                onClick={ pressedSubmit }
                disabled={ inProgress }
                value="Set"
              />
              <button className="button" onClick={ clickedClose }>Cancel</button>
            </div>

            { submitErrorMessage && (
              <article className="message is-danger">
                <div className="message-body">
                  { submitErrorMessage }
                </div>
              </article>
            )}

          </section>

        </div>
      </div>

    </a>
  )
}
export default DeprecateScanType
